import { Component, inject, OnDestroy } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { Subscription } from "rxjs";
import { ImageMedia } from "../../../../../../features/media/domain/models/media";
import { BrandService } from "../../../../../../shared/services/api/brand.service";
import { PublicationTemplateForm } from "../../../components/publication-template-form/publication-template-form";
import { InstagramSingleImageFields } from "../../../data/entities/publication-template-fields.entity";
import { PublicationTemplateType } from "../../../data/entities/publication-templates.entity";
import { InstagramSingleImage } from "../../../domain/models/instagram-single-image";

export interface InstagramPostForm {
  image: FormControl<ImageMedia | null>;
  text: FormControl<string | null>;
}

@Component({
  selector: "app-instagram-single-image-form",
  templateUrl: "./instagram-single-image-form.component.html",
  styleUrls: [
    "./instagram-single-image-form.component.scss",
    "../../../components/publication-template-form/publication-template-form.scss",
  ],
})
export class InstagramSingleImageFormComponent
  extends PublicationTemplateForm<InstagramPostForm>
  implements OnDestroy
{
  public fields!: InstagramSingleImageFields;
  private readonly subscription = new Subscription();
  protected readonly brandId = inject(BrandService).currentBrandId;

  constructor() {
    super(PublicationTemplateType.InstagramSingleImage);
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public createForm(): void {
    this.form = new FormGroup<InstagramPostForm>({
      image: new FormControl<ImageMedia | null>(null),
      text: new FormControl<string | null>(null),
    });
  }

  public setFormValues(ad: InstagramSingleImage): void {
    this.form.controls.image.patchValue(ad.image);
    this.form.controls.text = new FormControl<string | null>(ad.text);
  }
}
